import modules from '../modules';
import { breakpoints } from './variables';

const debounce = (callback: (args: unknown) => void, wait: number) => {
  let timerId: ReturnType<typeof setTimeout>;
  return (...args: [unknown]) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

const throttle = (callback: (args: unknown) => void, wait: number) => {
  let inThrottle: boolean;
  return (...args: [unknown]) => {
    if (!inThrottle) {
      callback(...args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, wait);
    }
  };
};
// Map number x from range [a, b] to [c, d]
const map = (x: number, a: number, b: number, c: number, d: number) =>
  ((x - a) * (d - c)) / (b - a) + c;
// Linear interpolation
const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;
const calcWinsize = () => {
  return { width: window.innerWidth, height: window.innerHeight };
};

// Gets the mouse position
const getMousePos = (e: { clientX: number; clientY: number }) => {
  return {
    x: e.clientX,
    y: e.clientY
  };
};

const distance = (x1: number, y1: number, x2: number, y2: number) => {
  const a = x1 - x2;
  const b = y1 - y2;
  return Math.hypot(a, b);
};

const isDesktop = () => {
  return window.matchMedia(`(min-width: ${breakpoints.desktop}px)`).matches;
};

const isSmallDesktop = () => {
  return window.matchMedia(`(min-width: ${breakpoints.smallDesktop}px)`).matches;
};

const isTabletLandscape = () => {
  return window.matchMedia(`(min-width: ${breakpoints.tabletLandscape}px)`).matches;
};

const isTablet = () => {
  return window.matchMedia(
    `(min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop - 1}px)`
  ).matches;
};

const isMobile = () => {
  return window.matchMedia(`(max-width: ${breakpoints.desktop - 1}px)`).matches;
};

const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  let browserName;
  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  } else {
    browserName = 'No browser detection';
  }
  return browserName;
};

const iOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};
export {
  iOS,
  debounce,
  throttle,
  map,
  lerp,
  calcWinsize,
  getMousePos,
  distance,
  isDesktop,
  isSmallDesktop,
  isTablet,
  isMobile,
  isTabletLandscape,
  prefersReducedMotion,
  getBrowserName
};

export const loadDeferredModules = async (el: Element) => {
  const deferredModules = el.querySelectorAll<HTMLElement>(
    '[data-module]:not([data-loaded="true"])'
  );
  deferredModules.forEach(node => {
    const mappedModule = modules.find(m => m.name === node.dataset.module);
    if (mappedModule) {
      mappedModule
        .loader?.()
        .then(module => {
          mappedModule.render?.(module.default, [node] as unknown as NodeListOf<HTMLElement>);
          node.dataset.loaded = 'true';
        })
        .catch(err => {
          console.log(`There was an error loading your module's javascript file - ${err}`);
        });
    }
  });
};

export const getEnvGQLUrl = () => {
  const baseUrl = import.meta.env.VITE_OPTIGRAPHQL_BASE_URL as string;

  if (document.querySelector('body')?.getAttribute('graph-env') === 'prd') {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_PROD_KEY}`;
  } else if (document.querySelector('body')?.getAttribute('graph-env') === 'stg') {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_STG_KEY}`;
  } else {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_INTE_KEY}`;
  }
};
